/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';



export class DxoEditingComponent extends NestedOption {
    
    get allowAdding(): boolean {
        return this._getOption('allowAdding');
    }
    set allowAdding(value: boolean) {
        this._setOption('allowAdding', value);
    }

    
    get allowDeleting(): boolean {
        return this._getOption('allowDeleting');
    }
    set allowDeleting(value: boolean) {
        this._setOption('allowDeleting', value);
    }

    
    get allowUpdating(): boolean {
        return this._getOption('allowUpdating');
    }
    set allowUpdating(value: boolean) {
        this._setOption('allowUpdating', value);
    }

    
    get editEnabled(): any {
        return this._getOption('editEnabled');
    }
    set editEnabled(value: any) {
        this._setOption('editEnabled', value);
    }

    
    get editMode(): any {
        return this._getOption('editMode');
    }
    set editMode(value: any) {
        this._setOption('editMode', value);
    }

    
    get form(): DevExpress.ui.dxFormOptions {
        return this._getOption('form');
    }
    set form(value: DevExpress.ui.dxFormOptions) {
        this._setOption('form', value);
    }

    
    get insertEnabled(): any {
        return this._getOption('insertEnabled');
    }
    set insertEnabled(value: any) {
        this._setOption('insertEnabled', value);
    }

    
    get mode(): string {
        return this._getOption('mode');
    }
    set mode(value: string) {
        this._setOption('mode', value);
    }

    
    get popup(): DevExpress.ui.dxPopupOptions {
        return this._getOption('popup');
    }
    set popup(value: DevExpress.ui.dxPopupOptions) {
        this._setOption('popup', value);
    }

    
    get removeEnabled(): any {
        return this._getOption('removeEnabled');
    }
    set removeEnabled(value: any) {
        this._setOption('removeEnabled', value);
    }

    
    get texts(): any {
        return this._getOption('texts');
    }
    set texts(value: any) {
        this._setOption('texts', value);
    }

    
    get allowDragging(): boolean {
        return this._getOption('allowDragging');
    }
    set allowDragging(value: boolean) {
        this._setOption('allowDragging', value);
    }

    
    get allowResizing(): boolean {
        return this._getOption('allowResizing');
    }
    set allowResizing(value: boolean) {
        this._setOption('allowResizing', value);
    }

    protected get _optionPath() {
        return 'editing';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-editing',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allowAdding': [{ type: Input },],
'allowDeleting': [{ type: Input },],
'allowUpdating': [{ type: Input },],
'editEnabled': [{ type: Input },],
'editMode': [{ type: Input },],
'form': [{ type: Input },],
'insertEnabled': [{ type: Input },],
'mode': [{ type: Input },],
'popup': [{ type: Input },],
'removeEnabled': [{ type: Input },],
'texts': [{ type: Input },],
'allowDragging': [{ type: Input },],
'allowResizing': [{ type: Input },],
};
}


export class DxoEditingModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoEditingComponent
  ],
  exports: [
    DxoEditingComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
